import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => {
    return (
      <select
        ref={ref}
        className={cn(
          "flex h-9 w-full rounded-md border border-admin-card-border bg-admin-card px-3 py-1 text-sm text-admin-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-admin-primary-focus disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer",
          className
        )}
        {...props}
      >
        {children}
      </select>
    );
  }
);
Select.displayName = "Select";

export { Select };
